import { RxJsonSchema } from 'rxdb';
import { LoggingModel } from '.';

export const loggingSchema: RxJsonSchema<LoggingModel> = {
	version: 0,
	primaryKey: 'dateTime',
	properties: {
		logLevel: {
			type: 'string'
		},
		body: {
			type: 'string'
		},
		title: {
			type: 'string'
		},
		dateTime: {
			type: 'string',
			maxLength: 1000
		}
	},
	type: 'object',
	description: ''
};
